module.exports = __webpack_public_path__ + "img/wallet-img.3c5cd5da.svg";